/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc
 */
import * as References from './ApplicationsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getAppComponentIndexByAppId
 */
export const GET_APP_COMPONENT_INDEX_BY_APP_ID_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsRpc_getAppComponentIndexByAppId';
export const GET_APP_COMPONENT_INDEX_BY_APP_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APP_COMPONENT_INDEX_BY_APP_ID_QUERY_FIELD_NAME,
  args: ['applicationId', 'appId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAppComponentIndexByAppIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getApplicationsForPortal
 */
export const GET_APPLICATIONS_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsRpc_getApplicationsForPortal';
export const GET_APPLICATIONS_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPLICATIONS_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['appFilters', 'applicationRequestExtras'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getApplicationsForPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getApplicationsByProjectAndPortal
 */
export const GET_APPLICATIONS_BY_PROJECT_AND_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsRpc_getApplicationsByProjectAndPortal';
export const GET_APPLICATIONS_BY_PROJECT_AND_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPLICATIONS_BY_PROJECT_AND_PORTAL_QUERY_FIELD_NAME,
  args: ['projectName', 'requestExtras'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getApplicationsByProjectAndPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getByClientId
 */
export const GET_BY_CLIENT_ID_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsRpc_getByClientId';
export const GET_BY_CLIENT_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_CLIENT_ID_QUERY_FIELD_NAME,
  args: ['clientId', 'applicationRequestExtras'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getByClientIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getById
 */
export const GET_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsRpc_getById';
export const GET_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_ID_QUERY_FIELD_NAME,
  args: ['appId', 'applicationRequestExtras'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getAppByComponentKey
 */
export const GET_APP_BY_COMPONENT_KEY_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsRpc_getAppByComponentKey';
export const GET_APP_BY_COMPONENT_KEY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APP_BY_COMPONENT_KEY_QUERY_FIELD_NAME,
  args: ['projectName', 'developerSymbol', 'revisionId', 'applicationRequestExtras'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getAppByComponentKeyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getByIds
 */
export const GET_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsRpc_getByIds';
export const GET_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_IDS_QUERY_FIELD_NAME,
  args: ['appIds', 'applicationRequestExtras'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getByIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getAiConnectorCatalog
 */
export const GET_AI_CONNECTOR_CATALOG_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsRpc_getAiConnectorCatalog';
export const GET_AI_CONNECTOR_CATALOG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AI_CONNECTOR_CATALOG_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getAiConnectorCatalogRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getLocalisedAppPermissions
 */
export const GET_LOCALISED_APP_PERMISSIONS_QUERY_FIELD_NAME = 'com_hubspot_applications_rpc_ApplicationsRpc_getLocalisedAppPermissions';
export const GET_LOCALISED_APP_PERMISSIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LOCALISED_APP_PERMISSIONS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getLocalisedAppPermissionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});